import React from "react";

import AGB from "components/agb";

const AGBPage = () => {
  return <AGB />;
};

export default AGBPage;
